module.exports = __webpack_public_path__ + "static/tat-29-8b02345fbc63354850e9b01404b1b27f.jpg";